export interface MatterLexiReloadDestination {
  matterNumber: number;
  resourceReference: string | null;
}

export function matterLexiAuthenticatedReloadPreviewDestination(
  destination: string,
): MatterLexiReloadDestination | null {
  try {
    const url = new URL(destination, 'https://forumandlex.invalid');
    const segments = url.pathname.split('/').filter(Boolean);
    if (segments.length < 3 || segments[0] !== 'matters' || segments[2] !== 'lexi') return null;
    const matterNumber = Number(segments[1]);
    if (!Number.isSafeInteger(matterNumber) || matterNumber <= 0) return null;
    return {
      matterNumber,
      resourceReference: segments[3] ? decodeURIComponent(segments[3]) : null,
    };
  } catch {
    return null;
  }
}
